import { FuelButton } from '@frete.com/fuel-react';
import { FC } from 'react';

import { ControlledTextField, Header } from '@/components';
import { ResponsibleFormValues, useResponsibleFormRules } from '@/hooks';

import * as Styled from './styled';
import { ResponsibleFormProps } from './types';

export const ResponsibleForm: FC<ResponsibleFormProps> = () => {
  const { handleClickBack, handleSubmit, validationSchema, initialValues } = useResponsibleFormRules();

  return (
    <>
      <Header title="Informe o responsável pela GR em sua empresa" action={handleClickBack} />
      <Styled.Container>
        <Styled.Description>
          Você não possui perfil de administrador. Informe os dados da pessoa responsável pela GR na sua empresa.
          Entraremos em contato com ela para que sua empresa possa aderir a GR Fretebras
        </Styled.Description>
        <Styled.Form<ResponsibleFormValues>
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          <Styled.Fields>
            <ControlledTextField
              label="Nome do(a) responsável"
              placeholder="Digite o nome do(a) responsável"
              name="name"
            />
            <ControlledTextField
              label="Número WhatsApp do(a) responsável"
              placeholder="Digite o Whatsapp do(a) responsável"
              mask={['(99) 9999-9999', '(99) 9 9999-9999']}
              name="phone"
            />
          </Styled.Fields>
          <Styled.Footer>
            <FuelButton type="submit" size="large">
              Enviar dados
            </FuelButton>
          </Styled.Footer>
        </Styled.Form>
      </Styled.Container>
    </>
  );
};
